import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getProductosCatalogoTienda, getProductosCatalogo } from '../../services/productosApi';
import { obtenerCategoriasTienda, obtenerCategorias } from '../../services/categoriasServicio';
import { obtenerConfiguracionTienda } from '../../services/configTiendaApi';
import { registrarPedidoWeb, registrarPedidoMesaPublico, consultarEstadoPedido, enviarCodigoValidacion, verificarCodigoValidacion, verificarTelefonoValidado } from '../../services/pedidosServicio';
import config, { resolveImagenUrl } from '../../config/apiConfig';
import CatalogoLista from './CatalogoLista';
import SelectorVariantesModal from '../Generales/SelectorVariantes';
import { GoogleMap, useJsApiLoader, Autocomplete, Marker, Polygon } from '@react-google-maps/api';
import config_ from '../../config/appConfig';
import { obtenerEstilosTienda, aplicarEstilos } from '../../services/themeService';

const libraries = ['places', 'geometry'];

const prepararTelefonoChile = (tel) => {
    if (!tel) return "";
    let limpio = tel.replace(/\D/g, '');
    if (limpio.length === 9) return "+56" + limpio;
    if (limpio.length === 11 && limpio.startsWith('56')) return "+" + limpio;
    if (limpio.startsWith('569')) return "+" + limpio;
    return tel.startsWith('+') ? tel : "+" + limpio;
};

function Pedidos() {
    const { slug } = useParams();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const esModoQR = location.pathname.startsWith('/negocio/') || location.pathname.startsWith('/cli/') || location.pathname === `/${slug}` || queryParams.get('modo') === 'qr';
    const mesaId = queryParams.get('mesa_id'); // 🚩 Detectar mesa_id desde QR
    const esModoMesa = esModoQR && mesaId; // QR + mesa_id = modo pedido en mesa
    // 🚩 Pedidos web (delivery/retiro por link directo) pausado por decision de
    // negocio: todo queda de solo lectura salvo el pedido-desde-mesa via QR
    // (esModoMesa), que es parte de la experiencia de Restaurante, no de
    // "pedidos web" propiamente tal.
    const [esSoloLectura, setEsSoloLectura] = useState(!esModoMesa);
    const [enviandoMesa, setEnviandoMesa] = useState(false);
    const [mensajeExitoMesa, setMensajeExitoMesa] = useState(null);

    const [metodosPagoServidor, setMetodosPagoServidor] = useState(null);
    const [comprobanteFile, setComprobanteFile] = useState(null);
    const [comprobantePreview, setComprobantePreview] = useState(null);
    const [urlComprobante, setUrlComprobante] = useState('');
    const [subiendoComprobante, setSubiendoComprobante] = useState(false);

    // 🚩 Cuando se detecta usa_menu_qr desde la BD, activar modo solo lectura
    useEffect(() => {
        if (usaMenuQr) {
            setEsSoloLectura(true);
        }
    }, [usaMenuQr]);

    // 🚩 BLOQUEO DE SEGURIDAD (Esto es vital para no dejar residuos en el estado)
    useEffect(() => {
        if (esSoloLectura) {
            setCarro([]);
            setIsCarritoVisible(false);
            setIsFormVisible(false);
        }
    }, [esSoloLectura]);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: config_.google_api,
        libraries: libraries
    });

    const esModoMenu = queryParams.get('modo') === 'menu';
    const esModoCatalogo = queryParams.get('modo') === 'catalogo';


    const mapaEstados = { 1: 0, 2: 1, 3: 2, 4: 2, 5: 3 };

    const estadosConfig = [
        { texto: "Recibimos tu pedido", icono: "📝", anim: "pulse" },
        { texto: "Preparando tu pedido...", icono: "👨‍🍳", anim: "spin" },
        { texto: "Pedido en camino / Listo", icono: "🛵", anim: "bounce" },
        { texto: "¡Entregado!", icono: "✅", anim: "none" }
    ];

    const [configLocal, setConfigLocal] = useState({ nombre: "Cargando...", colorPrimario: "#666", telefono: "" });
    const [estilosQr, setEstilosQr] = useState({});
    const [usaMenuQr, setUsaMenuQr] = useState(false);
    const [productos, setProductos] = useState([]);
    const [categoriasFull, setCategoriasFull] = useState([]);
    const [categoriasNombres, setCategoriasNombres] = useState(['Todos']);
    const [categoriaActiva, setCategoriaActiva] = useState('Todos');
    const [carro, setCarro] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isCarritoVisible, setIsCarritoVisible] = useState(false);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [datosCliente, setDatosCliente] = useState({ nombre: '', telefono: '', direccion: '', observacion: '', verDetalle: false });
    const [captchaOk, setCaptchaOk] = useState(false);

    // 🚗 CAPTCHA ROTATIVO
    const POOL_CAPTCHA = [
        { emoji: '🚗', nombre: 'Auto' },
        { emoji: '🏠', nombre: 'Casa' },
        { emoji: '🌮', nombre: 'Taco' },
        { emoji: '🍕', nombre: 'Pizza' },
        { emoji: '🐶', nombre: 'Perro' },
        { emoji: '🐱', nombre: 'Gato' },
        { emoji: '☕', nombre: 'Café' },
        { emoji: '🍔', nombre: 'Hamburguesa' },
        { emoji: '🦁', nombre: 'León' },
        { emoji: '🚀', nombre: 'Cohete' },
        { emoji: '🎸', nombre: 'Guitarra' },
        { emoji: '🏀', nombre: 'Balón' },
        { emoji: '🐧', nombre: 'Pingüino' },
        { emoji: '🦄', nombre: 'Unicornio' },
        { emoji: '🍦', nombre: 'Helado' },
        { emoji: '🌵', nombre: 'Cactus' },
        { emoji: '🎂', nombre: 'Pastel' },
        { emoji: '🌻', nombre: 'Flor' },
        { emoji: '🎮', nombre: 'Videojuego' },
        { emoji: '🐘', nombre: 'Elefante' },
        { emoji: '🍩', nombre: 'Dona' },
        { emoji: '🎈', nombre: 'Globo' },
        { emoji: '🐸', nombre: 'Rana' },
        { emoji: '🦊', nombre: 'Zorro' },
    ];
    const generarCaptcha = () => {
        const disponibles = [...POOL_CAPTCHA];
        const correcto = disponibles[Math.floor(Math.random() * disponibles.length)];
        const distractores = disponibles
            .filter(d => d.emoji !== correcto.emoji)
            .sort(() => Math.random() - 0.5)
            .slice(0, 4);
        const opciones = [correcto, ...distractores].sort(() => Math.random() - 0.5);
        return { correcto, opciones };
    };
    const [captchaData, setCaptchaData] = useState(generarCaptcha);
    const [captchaFallos, setCaptchaFallos] = useState(0);
    const [captchaBloqueado, setCaptchaBloqueado] = useState(false);

    const handleCaptchaClick = (emoji) => {
        if (captchaBloqueado) return;
        if (emoji === captchaData.correcto.emoji) {
            setCaptchaOk(true);
            setCaptchaFallos(0);
        } else {
            const nuevosFallos = captchaFallos + 1;
            setCaptchaFallos(nuevosFallos);
            if (nuevosFallos >= 3) {
                setCaptchaBloqueado(true);
                setTimeout(() => {
                    setCaptchaBloqueado(false);
                    setCaptchaFallos(0);
                    setCaptchaData(generarCaptcha());
                }, 5000);
            } else {
                setCaptchaData(generarCaptcha());
            }
        }
    };

    const [pedidoActivo, setPedidoActivo] = useState(null);
    const [estadoActual, setEstadoActual] = useState(0);

    const [esperandoValidacion, setEsperandoValidacion] = useState(false);
    const [codigoValidacion, setCodigoValidacion] = useState("");
    const [codigoEnviado, setCodigoEnviado] = useState(false);
    const [enviandoCodigo, setEnviandoCodigo] = useState(false);
    const [mensajeValidacion, setMensajeValidacion] = useState(null);
    const [mensajeRechazo, setMensajeRechazo] = useState(null);
    const [productoParaVariantes, setProductoParaVariantes] = useState(null);
    const [tipoEntrega, setTipoEntrega] = useState('delivery');
    const [metodoPago, setMetodoPago] = useState(''); // '' = sin seleccionar

    // Métodos de pago disponibles según tipo de entrega
    const METODOS_PAGO = {
        delivery: [
            { id: 'efectivo', label: '💵 Efectivo', desc: 'Paga al repartidor' },
            { id: 'transferencia', label: '🏦 Transferencia', desc: 'Datos de la cuenta al confirmar' },
        ],
        retiro: [
            { id: 'efectivo', label: '💵 Efectivo', desc: 'Paga cuando retires' },
            { id: 'transferencia', label: '🏦 Transferencia', desc: 'Datos de la cuenta al confirmar' },
            { id: 'tarjeta', label: '💳 Tarjeta', desc: 'Débito o crédito en el local' },
        ]
    };

    const [sectores, setSectores] = useState([]);
    const [sectorElegido, setSectorElegido] = useState(null);
    const [mapCenter, setMapCenter] = useState({ lat: -33.4489, lng: -70.6693 });
    const [marcador, setMarcador] = useState(null);
    const [fueraDeRango, setFueraDeRango] = useState(false);
    const [autocompleteInstance, setAutocompleteInstance] = useState(null);

    useEffect(function () {
        let intervalo;
        if (pedidoActivo && pedidoActivo.id && estadoActual < 3 && estadoActual !== -1) {
            intervalo = setInterval(async function () {
                try {
                    const data = await consultarEstadoPedido(pedidoActivo.id);
                    if (data && data.status === 'success' && data.estado_id) {
                        const serverEstadoId = parseInt(data.estado_id);
                        if (serverEstadoId === 6) {
                            setEstadoActual(-1);
                            clearInterval(intervalo);
                            return;
                        }
                        const nuevoIndiceUI = mapaEstados[serverEstadoId];
                        if (nuevoIndiceUI !== undefined && nuevoIndiceUI !== estadoActual) {
                            setEstadoActual(nuevoIndiceUI);
                        }
                        // Actualizar items y total desde el backend para el detalle
                        if (data.items) {
                            setPedidoActivo(prev => ({
                                ...prev,
                                items: data.items,
                                total: data.total,
                                tipo_entrega_id: data.tipo_entrega_id,
                                direccion: data.direccion,
                                costo_envio: data.costo_envio
                            }));
                        }
                    }
                } catch (e) { console.error("Error polling:", e); }
            }, 8000);
        }
        return () => { if (intervalo) clearInterval(intervalo); };
    }, [pedidoActivo, estadoActual]);

    // CARGA INICIAL Y LIMPIEZA ABSOLUTA DE POLÍGONOS
    useEffect(() => {
        console.log("ingrez")
        const fetchDatosDB = async () => {
            setLoading(true);
            try {
                // =========================================================
                // 🚩 1. BLOQUEO ESTRICTO DE PEDIDOS WEB (USA_WEB)
                // =========================================================
                // 🚩 1. OBTENER CONFIGURACIÓN PÚBLICA
                const resConfig = await fetch(`${config.api_url}/api/configuracion/valores-publicos/${slug}`);
                const dataConfig = await resConfig.json();
                const ajustes = dataConfig.ajustes ? dataConfig.ajustes : {};

                // 🚩 Detectar flag usa_menu_qr desde la BD
                const tieneMenuQr = ajustes.usa_menu_qr == 1 || ajustes.usa_menu_qr === "1" || ajustes.usa_menu_qr === true;
                setUsaMenuQr(tieneMenuQr);

                // 🚩 BLOQUEO: Si es modo QR y no tiene flag activo, rechazar
                if (esModoQR && !tieneMenuQr) {
                    setMensajeRechazo("qr_no_habilitado");
                    setLoading(false);
                    return;
                }

                // 🚩 BLOQUEO DE PEDIDOS WEB (USA_WEB) - solo si NO es modo QR
                if (!esModoQR) {
                    const usaWeb = ajustes.usa_web;
                    if (usaWeb === 0 || usaWeb === "0" || usaWeb === false) {
                        setMensajeRechazo("no_disponible");
                        setLoading(false);
                        return;
                    }
                }

                // =========================================================
                // 🚩 2. CARGA DE ESTILOS PERSONALIZADOS
                // =========================================================
                const estilosTienda = await obtenerEstilosTienda(slug);
                aplicarEstilos(estilosTienda, 'pedidos_web');
                setEstilosQr(estilosTienda.carta_qr || {});

                // =========================================================
                // 🚩 3. CARGA DE DATOS DE TIENDA Y ESTADO
                // =========================================================
                const respConfig = await obtenerConfiguracionTienda(slug);
                if (respConfig) {
                    setConfigLocal(respConfig);
                    // 🏦 Cargar datos de transferencia si existen
                    if (respConfig.datos_transferencia) {
                        setMetodosPagoServidor(respConfig.datos_transferencia);
                    }
                }

                const guardado = localStorage.getItem('pedido_' + slug);
                if (guardado) {
                    const pedidoObj = JSON.parse(guardado);
                    setPedidoActivo(pedidoObj);
                    const dataReal = await consultarEstadoPedido(pedidoObj.id).catch(() => null);
                    if (dataReal && dataReal.estado_id) {
                        if (parseInt(dataReal.estado_id) === 6) setEstadoActual(-1);
                        else setEstadoActual(mapaEstados[parseInt(dataReal.estado_id)] || 0);
                        // 🚩 Sincronizar items desde el backend al recargar
                        if (dataReal.items) {
                            setPedidoActivo(prev => ({
                                ...prev,
                                items: dataReal.items,
                                total: dataReal.total,
                                tipo_entrega_id: dataReal.tipo_entrega_id,
                                direccion: dataReal.direccion,
                                costo_envio: dataReal.costo_envio
                            }));
                        }
                    }
                }

                // =========================================================
                // 🚩 3. OBTENCIÓN DE PRODUCTOS Y CATEGORÍAS
                // =========================================================

                const urlProductos = esModoQR
                    ? `${config.api_url}/api/productos/catalogo/publico/${slug}?modo=qr`
                    : `${config.api_url}/api/productos/catalogo/publico/${slug}`;

                const pCategorias = obtenerCategoriasTienda(slug).catch(() => []);
                const pProductos = fetch(urlProductos).then(r => r.json()).catch(() => [])
                //const pProductos = getProductosCatalogo();
                const urlSectores = `${config.api_url ? config.api_url.replace(/\/+$/, '') : ""}/api/sectores-despacho-publico/${slug}`;
                const pSectores = fetch(urlSectores).then(res => res.ok ? res.json() : []).catch(() => []);

                const [respCat, respProd, respSectores] = await Promise.all([pCategorias, pProductos, pSectores]);
                console.log("DEBUG 1: Respuesta cruda de Productos:", respProd);
                // =========================================================
                // 🚩 4. NORMALIZACIÓN (SIN OPTIONAL CHAINING PARA EVITAR ERRORES)
                // =========================================================

                // --- Categorías ---
                const arrayCategorias = Array.isArray(respCat) ? respCat : (respCat && respCat.data ? respCat.data : []);
                setCategoriasFull(arrayCategorias);
                const nombresCat = arrayCategorias.map(c => c.nombre).filter(Boolean);
                setCategoriasNombres(['Todos', ...new Set(nombresCat)]);

                // --- Productos ---
                let arrayProductos = [];
                if (Array.isArray(respProd)) {
                    arrayProductos = respProd;
                } else if (respProd) {
                    arrayProductos = respProd.data || respProd.productos || [];
                }
                setProductos(arrayProductos);

                // --- Sectores ---
                let dataSectores = [];
                if (Array.isArray(respSectores)) {
                    dataSectores = respSectores;
                } else if (respSectores) {
                    dataSectores = respSectores.data || respSectores.sectores || [];
                }

                const sectoresParseados = dataSectores.map(s => {
                    try {
                        let coords = typeof s.poligono === 'string' ? JSON.parse(s.poligono) : s.poligono;
                        if (Array.isArray(coords) && coords.length > 0 && Array.isArray(coords[0])) coords = coords[0];
                        return { ...s, poligono: (coords || []).map(c => ({ lat: parseFloat(c.lat), lng: parseFloat(c.lng) })) };
                    } catch (e) { return { ...s, poligono: [] }; }
                }).filter(s => s.poligono.length > 2);

                setSectores(sectoresParseados);
                if (sectoresParseados.length > 0 && sectoresParseados[0].poligono.length > 0) setMapCenter(sectoresParseados[0].poligono[0]);

            } catch (error) {
                console.error("Error fatal de carga:", error);
                setMensajeRechazo("Error al cargar el comercio.");
            } finally {
                setLoading(false);
            }
        };

        if (slug) fetchDatosDB();
    }, [slug, esModoQR]);
    // 🚩 VALIDACIÓN IMPECABLE DEL POLÍGONO
    const verificarCobertura = (ubicacion) => {
        if (!window.google || !window.google.maps.geometry) return;

        const lat = parseFloat(ubicacion.lat);
        const lng = parseFloat(ubicacion.lng);
        const punto = new window.google.maps.LatLng(lat, lng);

        setMarcador({ lat, lng });
        setMapCenter({ lat, lng });

        let sectorEncontrado = null;

        for (const s of sectores) {
            try {
                // Instanciar LatLng strictly de Google
                const googlePaths = s.poligono.map(p => new window.google.maps.LatLng(p.lat, p.lng));
                const polygonGoogle = new window.google.maps.Polygon({ paths: googlePaths });

                if (window.google.maps.geometry.poly.containsLocation(punto, polygonGoogle)) {
                    sectorEncontrado = s;
                    break;
                }
            } catch (err) {
                console.error("Error al validar el polígono:", err);
            }
        }

        if (sectorEncontrado) {
            setSectorElegido(sectorEncontrado);
            setFueraDeRango(false);
        } else {
            setSectorElegido(null);
            setFueraDeRango(true);
        }
    };


    const onPlaceChanged = () => {
        if (autocompleteInstance !== null) {
            const place = autocompleteInstance.getPlace();
            if (place.geometry && place.geometry.location) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                const address = place.formatted_address;
                setDatosCliente(prev => ({ ...prev, direccion: address }));
                verificarCobertura({ lat, lng });
            }
        }
    };

    const onMapClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === 'OK' && results[0]) {
                setDatosCliente(prev => ({ ...prev, direccion: results[0].formatted_address }));
            } else {
                setDatosCliente(prev => ({ ...prev, direccion: "Ubicación seleccionada en el mapa" }));
            }
        });
        verificarCobertura({ lat, lng });
    };

    const subtotal = useMemo(() => carro.reduce((acc, item) => acc + (Number(item.precio) * item.cantidad), 0), [carro]);

    const totalFinal = useMemo(() => {
        if (tipoEntrega === 'retiro') return subtotal;
        return subtotal + (sectorElegido ? Number(sectorElegido.valor_entrega) : 0);
    }, [subtotal, sectorElegido, tipoEntrega]);

    // Dentro de Pedidos.js (Web)
    const handleAdd = (p) => {
        if (esSoloLectura) return;

        // 🚩 VALIDACIÓN REAL: ¿Tiene grupos con opciones?
        const tieneVariantes = p.grupos && p.grupos.length > 0;
        const yaPersonalizado = p.opciones_escogidas || (p.id && String(p.id).includes('_'));

        if (tieneVariantes && !yaPersonalizado) {
            setProductoParaVariantes(p); // Abre el modal
            return;
        }

        // Si no tiene variantes o ya pasó por el modal, agrega al carro
        const precioItem = Number(p.precio || p.valor || 0); // 🚩 Usa ambas llaves por seguridad

        const textoVariantesP = p.variantes_detalles || p.descripcionVariantes || "";
        setCarro(prev => {
            const ex = prev.find(i => {
                const textoVariantesI = i.variantes_detalles || i.descripcionVariantes || "";
                return i.id === p.id && textoVariantesI === textoVariantesP;
            });
            if (ex) {
                return prev.map(i => (i.id === p.id && (i.variantes_detalles || i.descripcionVariantes || "") === textoVariantesP)
                    ? { ...i, cantidad: i.cantidad + 1 } : i);
            }
            return [...prev, { ...p, precio: precioItem, cantidad: 1 }];
        });
    };

    const handleRemove = (id) => setCarro(prev => {
        const ex = prev.find(i => i.id === id);
        if (!ex) return prev;
        return ex.cantidad === 1 ? prev.filter(i => i.id !== id) : prev.map(i => i.id === id ? { ...i, cantidad: i.cantidad - 1 } : i);
    });

    // 🚩 ENVIAR PEDIDO DE MESA A COCINA (Público, sin token)
    const enviarPedidoMesa = async () => {
        if (!slug || !mesaId || carro.length === 0) return;
        setEnviandoMesa(true);
        try {
            const payload = {
                slug,
                mesa_id: mesaId,
                items: carro,
                comensales: 1
            };
            const res = await registrarPedidoMesaPublico(payload);
            if (res.status === 'success') {
                setIsCarritoVisible(false);
                const nuevoPedido = {
                    id: res.id,
                    display_id: res.display_id,
                    items: carro,
                    total: subtotal,
                    tipo_entrega_id: 1
                };
                setPedidoActivo(nuevoPedido);
                setEstadoActual(0);
                setMensajeExitoMesa(res.message || '¡Pedido enviado a cocina!');
                localStorage.setItem(`pedido_${slug}`, JSON.stringify(nuevoPedido));
                setCarro([]);
            } else {
                alert(res.message || 'Error al enviar el pedido.');
            }
        } catch (e) {
            alert('Error inesperado al conectar con el servidor.');
        } finally {
            setEnviandoMesa(false);
        }
    };

    // 🚩 VERIFICAR CÓDIGO SMS ANTES DE ENVIAR EL PEDIDO
    const verificarCodigoSms = async () => {
        const telVia = prepararTelefonoChile(datosCliente.telefono);
        if (!codigoValidacion || codigoValidacion.length < 6) {
            setMensajeValidacion({ tipo: 'danger', texto: 'Ingresa el código de 6 dígitos.' });
            return false;
        }
        setLoading(true);
        try {
            const res = await verificarCodigoValidacion(telVia, codigoValidacion);
            if (res.status === 'verified') {
                setMensajeValidacion({ tipo: 'success', texto: '✅ Teléfono validado correctamente.' });
                setEsperandoValidacion(false);
                setCodigoEnviado(false);
                setCodigoValidacion("");
                return true;
            } else {
                setMensajeValidacion({ tipo: 'danger', texto: res.message || 'Código incorrecto.' });
                return false;
            }
        } catch (e) {
            setMensajeValidacion({ tipo: 'danger', texto: 'Error al verificar código.' });
            return false;
        } finally {
            setLoading(false);
        }
    };

    const finalizarPedido = async () => {
        const telVia = prepararTelefonoChile(datosCliente.telefono);

        // 🚩 Si está esperando validación, primero verificar el código
        if (esperandoValidacion) {
            const verificacionOk = await verificarCodigoSms();
            if (!verificacionOk) return;
            // Si se verificó, continuar con el envío del pedido
        }

        if (!datosCliente.nombre || !datosCliente.telefono) {
            alert("Por favor completa tu nombre y teléfono."); return;
        }

        if (!metodoPago) {
            alert("Por favor selecciona un método de pago."); return;
        }

        if (tipoEntrega === 'delivery') {
            if (!datosCliente.direccion || !sectorElegido || fueraDeRango) {
                alert("Para delivery debes ingresar una ubicación válida dentro de la zona de reparto."); return;
            }
            if (subtotal < Number(sectorElegido.monto_minimo_pedido || 0)) {
                alert(`El pedido mínimo para ${sectorElegido.nombre_sector} es $${Number(sectorElegido.monto_minimo_pedido).toLocaleString()}`); return;
            }
        }

        setLoading(true);
        try {
            const payload = {
                slug,
                nombre: datosCliente.nombre,
                telefono: telVia,
                direccion: tipoEntrega === 'retiro' ? 'Retiro en Local' : datosCliente.direccion,
                observacion: datosCliente.observacion,
                items: carro,
                tipo_entrega: tipoEntrega,
                sector_id: tipoEntrega === 'retiro' ? null : (sectorElegido ? sectorElegido.id : null),
                costo_envio: tipoEntrega === 'retiro' ? 0 : Number(sectorElegido ? sectorElegido.valor_entrega : 0),
                total: subtotal,
                total_pagado: totalFinal,
                valor_pedido: subtotal,
                metodo_pago: metodoPago,
                lat: marcador ? marcador.lat : null,
                lng: marcador ? marcador.lng : null
            };

            const res = await registrarPedidoWeb(payload, comprobanteFile);
            if (res.status === "blocked") { setMensajeRechazo(res.message); setIsFormVisible(false); return; }
            if (res.status === "require_validation") { setEsperandoValidacion(true); return; }
            if (res.status === "success") {
                setIsCarritoVisible(false); setIsFormVisible(false);
                const nuevoPedido = { id: res.id, display_id: res.display_id, cliente: { nombre: datosCliente.nombre }, items: carro, total: subtotal, tipo_entrega_id: tipoEntrega === 'delivery' ? 2 : 3, direccion: datosCliente.direccion, costo_envio: tipoEntrega === 'delivery' ? (sectorElegido ? Number(sectorElegido.valor_entrega) : 0) : 0 };
                setPedidoActivo(nuevoPedido); setEstadoActual(0);
                setDatosCliente(prev => ({ ...prev, verSeguimiento: true }));
                localStorage.setItem(`pedido_${slug}`, JSON.stringify(nuevoPedido));
                setCarro([]); return;
            }
            alert(res.message || "Error al procesar el pedido.");
        } catch (e) { alert("Error inesperado."); } finally { setLoading(false); }
    };

    const resetearParaNuevoPedido = () => {
        localStorage.removeItem(`pedido_${slug}`);
        setPedidoActivo(null); setEstadoActual(0); setCarro([]); setSectorElegido(null); setCaptchaOk(false); setMarcador(null); setFueraDeRango(false);
        window.scrollTo(0, 0);
    };

    const productosFiltrados = useMemo(() => {
        if (!productos || productos.length === 0) return [];
        if (categoriaActiva === 'Todos') return productos;
        return productos.filter(p => {
            const catProdNombre = (p.categoria_nombre || p.categoria || "").toString().toLowerCase().trim();
            const catRel = categoriasFull.find(c => c.nombre === categoriaActiva);

            // 1. Filtro por nombre exacto
            if (catProdNombre === categoriaActiva.toLowerCase().trim()) return true;

            // 2. Filtro por ID (Forzando a String para que no falle)
            if (catRel) {
                if (String(p.categoria_id) === String(catRel.id)) return true;
                if (String(p.id_categoria) === String(catRel.id)) return true;
            }

            return false;
        });
    }, [productos, categoriaActiva, categoriasFull]);

    const obtenerUrlImagen = (producto) => {
        const imgDefault = "https://via.placeholder.com/300?text=Sin+Imagen";
        const path = producto.url_imagen || producto.img || producto.imagen;
        if (!path || path === "null" || path === "" || path === undefined) return imgDefault;
        return resolveImagenUrl(path);
    };

    // Formateador específico para el Logo y Banner usando R2
    const obtenerUrlTiendaR2 = (path) => {
        if (!path || path === "null" || path === "" || path === undefined) return null;
        return resolveImagenUrl(path);
    };



    // Variables finales listas para usar en el HTML
    const logoFinal = obtenerUrlTiendaR2(configLocal.url_logo || configLocal.urlLogo || configLocal.logo_url);
    const bannerFinal = obtenerUrlTiendaR2(configLocal.url_cabecera || configLocal.urlCabecera);

    // Estilos carta QR
    const headerBg = estilosQr.header_bg || estilosQr.color_primario || configLocal.colorPrimario || '#F26B21';
    const headerText = estilosQr.header_text_color || '#FFFFFF';
    const footerBg = estilosQr.footer_bg || '#1a1c1d';
    const footerText = estilosQr.footer_text_color || '#FFFFFF';
    const logoSizes = { pequeño: 60, mediano: 80, grande: 100 };
    const logoSize = logoSizes[estilosQr.logo_tamano] || 80;

    // 🕵️‍♂️ === RASTREADOR DE DEBUG (MÍRALO EN LA CONSOLA F12) ===
    useEffect(() => {
        if (configLocal && configLocal.nombre !== "Cargando...") {
            console.log("🟦 === DEBUG CABECERA Y LOGO ===");
            console.log("1. Todo el objeto configLocal:", configLocal);
            console.log("--- LOGO ---");
            console.log("2. url_logo:", configLocal.url_logo, " | RESULTADO:", logoFinal);
            console.log("--- CABECERA ---");
            console.log("3. url_cabecera:", configLocal.url_cabecera);
            console.log("4. urlCabecera:", configLocal.urlCabecera);
            console.log("5. RESULTADO bannerFinal:", bannerFinal);
            console.log("🟦 ==============================");
        }
    }, [configLocal, logoFinal, bannerFinal]);
    // 🚩 Si hay mensaje de rechazo, NO renderizar el layout de la tienda (solo el modal)
    if (mensajeRechazo) {
        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f8fafc' }}>
                <style>{`
                    .modal-custom { 
                        position: fixed; 
                        top: 0; left: 0; 
                        width: 100%; height: 100%; background-color: rgba(0,0,0,0.85); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 20px; overflow-y: auto; }
                `}</style>

                {mensajeRechazo === "qr_no_habilitado" && (
                    <div className="modal-custom">
                        <div className="bg-white p-5 rounded-4 text-center shadow-2xl" style={{ maxWidth: '380px', borderRadius: '24px' }}>
                            <div className="mb-4" style={{ fontSize: '4rem' }}>🔒</div>
                            <h2 className="fw-bold mb-3" style={{ color: '#1a1c1d', fontSize: '1.5rem' }}>Modo QR no disponible</h2>
                            <p className="text-muted mb-4" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                                El comercio no tiene habilitado el modo QR.<br />
                                <span style={{ fontSize: '0.8rem' }}>Contacta al comercio para más información.</span>
                            </p>
                            <button className="btn btn-dark w-100 rounded-pill py-3 fw-bold shadow-sm" onClick={() => setMensajeRechazo(null)}>
                                ENTENDIDO
                            </button>
                        </div>
                    </div>
                )}

                {mensajeRechazo === "no_disponible" && (
                    <div className="modal-custom">
                        <div className="bg-white p-5 rounded-4 text-center shadow-2xl" style={{ maxWidth: '400px', borderRadius: '24px' }}>
                            <div className="mb-3" style={{ fontSize: '4rem', lineHeight: 1 }}>🛒</div>
                            <div style={{
                                width: '70px', height: '70px', borderRadius: '50%', margin: '0 auto 16px',
                                backgroundColor: '#f0fdf4', display: 'flex', alignItems: 'center',
                                justifyContent: 'center', fontSize: '2rem'
                            }}>
                                🚧
                            </div>
                            <h2 className="fw-bold mb-2" style={{ color: '#1a1c1d', fontSize: '1.4rem' }}>
                                {configLocal.nombre !== "Cargando..." ? configLocal.nombre : 'Esta tienda'}
                            </h2>
                            <p className="text-muted mb-3" style={{ fontSize: '0.85rem', lineHeight: '1.5' }}>
                                Estamos preparando nuestra tienda online 🚀
                            </p>
                            <div style={{
                                backgroundColor: '#f8fafc', borderRadius: '12px', padding: '14px',
                                marginBottom: '20px', border: '1px solid #e2e8f0'
                            }}>
                                <div style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: '4px' }}>
                                    ⏳ Pronto podrás pedir desde aquí
                                </div>
                                <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                                    Mientras tanto, puedes visitarnos directamente en nuestro local
                                </div>
                            </div>
                            <div className="d-flex flex-column gap-2">
                                <button className="btn btn-dark w-100 rounded-pill py-3 fw-bold shadow-sm" onClick={() => setMensajeRechazo(null)}>
                                    ENTENDIDO, VOLVER
                                </button>
                                {configLocal.direccion && (
                                    <p className="text-muted mt-2 mb-0" style={{ fontSize: '0.75rem' }}>
                                        📍 {configLocal.direccion}
                                    </p>
                                )}
                                <p className="text-muted mt-2 mb-0" style={{ fontSize: '0.7rem' }}>
                                    ¿Eres el dueño? <a href="/adminlogin" style={{ color: '#008060', fontWeight: 600, textDecoration: 'underline' }}>Activa tu tienda online</a>
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {mensajeRechazo && mensajeRechazo !== "no_disponible" && mensajeRechazo !== "qr_no_habilitado" && (
                    <div className="modal-custom">
                        <div className="bg-white p-5 rounded-4 text-center shadow-2xl" style={{ maxWidth: '380px', borderRadius: '24px' }}>
                            <div className="mb-3" style={{ fontSize: '3rem', lineHeight: 1 }}>😅</div>
                            <h3 className="fw-bold mb-3" style={{ color: '#1a1c1d', fontSize: '1.2rem' }}>
                                Algo salió mal
                            </h3>
                            <p className="text-muted mb-4" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                                {mensajeRechazo || 'No pudimos cargar la información del comercio.'}
                            </p>
                            <button className="btn btn-dark w-100 rounded-pill py-3 fw-bold shadow-sm" onClick={() => setMensajeRechazo(null)}>
                                ENTENDIDO
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="min-vh-100" style={{ backgroundColor: 'var(--pw-color-fondo, #f4f7f6)' }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap');
                .bg-light {
                    background-color: var(--pw-color-fondo, #f4f7f6) !important;
                }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                .anim-spin { animation: spin 2s infinite linear; }
                @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.05); } 100% { transform: scale(1); } }
                .anim-pulse { animation: pulse 1.5s infinite; }
                
                /* ESTILOS PREMIUM - HEADER COMPACTO ESTILO GOMENU */
                .store-banner { height: var(--pw-banner-altura, 80px); background-size: cover; background-position: center; position: relative; }
                .logo-container { width: 70px; height: 70px; background: white; border-radius: var(--pw-border-radius-card, 16px); padding: 3px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); margin: -35px auto 0 auto; position: relative; z-index: 10; display: flex; align-items: center; justify-content: center; overflow: hidden; }
                .logo-img { width: 100%; height: 100%; object-fit: contain; border-radius: 16px; }
              /* 1. El contenedor: Dale un fondo sutil y aire */
                /* EL CONTENEDOR: Ahora es un "vidrio" que flota */
.category-bar {
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(15px) !important; /* Efecto iPhone */
    border-bottom: 1px solid rgba(0,0,0,0.05) !important;
    padding: 12px 0 !important;
    display: flex !important;
    overflow-x: auto !important;
    white-space: nowrap !important;
    scrollbar-width: none !important; /* Esconde scroll en Firefox */
    scroll-behavior: smooth !important;
    -webkit-overflow-scrolling: touch !important;
}

.category-bar::-webkit-scrollbar { 
    display: none !important; /* Esconde scroll en Chrome/Safari */
}

/* LOS BOTONES (PILLS): Estilo Shopify/Uber */
.btn-category {
    background-color: var(--pw-categoria-inactiva-bg, #f1f3f5) !important;
    color: var(--pw-categoria-inactiva-texto, #495057) !important;
    border: 1px solid transparent !important;
    border-radius: var(--pw-border-radius-pill, 50px) !important;
    padding: 8px 20px !important;
    margin: 0 6px !important;
    font-size: 0.85rem !important;
    font-weight: 700 !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    display: inline-block !important;
    box-shadow: var(--pw-sombra-card, 0 2px 4px rgba(0,0,0,0.02)) !important;
}

/* EL BOTÓN ACTIVO: El que manda */
.btn-category.active {
    background-color: ${headerBg} !important;
    color: ${headerText} !important;
    transform: scale(1.05) !important;
    box-shadow: 0 8px 15px rgba(0,0,0,0.15) !important;
    border-color: ${headerBg} !important;
}

/* Efecto de presión al tocar */
.btn-category:active {
    transform: scale(0.95) !important;
}
                .no-scrollbar::-webkit-scrollbar { display: none; }
                .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

                /* MODALES Y ELEMENTOS ORIGINALES */
                .modal-custom { 
                    position: fixed; 
                    top: 0; left: 0; 
                    width: 100%; height: 100%; background-color: rgba(0,0,0,0.85); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 20px; overflow-y: auto; }
                .modal-content-card { 
                    background: white; 
                    width: 100%; 
                    max-width: 500px; 
                    border-radius: var(--pw-border-radius-modal, 30px);
                    padding: 30px; 
                    box-shadow: 0 20px 40px rgba(0,0,0,0.4); 
                    max-height: 90vh; 
                    overflow-y: auto; 
                }
                    
                .qty-pill { display: flex; align-items: center; background: #f8f9fa; border-radius: var(--pw-border-radius-pill, 50px); padding: 2px 8px; border: 1px solid #dee2e6; }
                .qty-pill button { background: none; border: none; font-weight: bold; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; color: #333; }
                .qty-pill span { min-width: 25px; text-align: center; font-weight: 800; font-size: 14px; }
                .modo-lectura button, .modo-lectura .btn { display: none !important; }
                .modo-lectura .card, .modo-lectura .producto-item { cursor: default !important; pointer-events: none !important; }
                .pac-container { z-index: 100000 !important; border-radius: var(--pw-border-radius, 10px); border: none; box-shadow: 0 4px 12px rgba(0,0,0,0.2); margin-top: 5px; }

                            
                @media (min-width: 992px) {
                    .store-banner { height: 200px; }
                }
            `}</style>

            <div className="bg-white shadow-sm overflow-hidden" style={{ fontFamily: 'var(--pw-font-family, "Inter", sans-serif)' }}>
                {/* Banner de fondo */}
                <div className="store-banner" style={{ backgroundColor: headerBg, backgroundImage: bannerFinal ? `url(${bannerFinal})` : 'none' }}>
                    {bannerFinal && <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.3)' }}></div>}
                </div>

                {/* Logo Flotante */}
                <div className="logo-container" style={{ width: `${logoSize}px`, height: `${logoSize}px`, marginTop: `-${logoSize / 2}px` }}>
                    {logoFinal ? (
                        <img src={logoFinal} alt="Logo" className="logo-img" />
                    ) : (
                        <div className="fw-bold text-muted" style={{ fontSize: '24px' }}>{configLocal.nombre.charAt(0)}</div>
                    )}
                </div>
                {/* Info de tienda */}
                <div className="text-center pt-3 pb-3 px-3">
                    <h1 className="fw-800 mb-1" style={{ fontSize: '1.6rem', color: '#1a1c1d', fontWeight: 800 }}>{configLocal.nombre}</h1>
                    <div className="d-flex justify-content-center gap-3 mt-2 text-muted small fw-600">
                        <span>🕒 {configLocal.horario || 'Abierto'}</span>
                        <span>📍 {configLocal.direccion || 'Local'}</span>
                    </div>
                    {configLocal.descripcion && <p className="text-muted mt-2 mb-0 small px-4">{configLocal.descripcion}</p>}
                </div>

                {/* Etiquetas MODO */}
                {queryParams.get('modo') === 'menu' && <div className="bg-warning text-dark text-center py-1 fw-bold border-bottom small">📖 MODO MENÚ DIGITAL</div>}
                {queryParams.get('modo') === 'catalogo' && <div className="bg-info text-white text-center py-1 fw-bold border-bottom small">👀 MODO CARTA</div>}
                {esModoMesa && <div className="bg-success text-white text-center py-1 fw-bold border-bottom small">🍽️ PEDIDO EN MESA</div>}

                {/* Botones de Categoría (Sticky rediseñado) */}
                {/* Botones de Categoría (Sticky rediseñado) */}
                <div className="sticky-top category-bar shadow-sm">
                    <div className="d-flex px-3"> {/* Eliminamos clases de container que limitan el ancho */}
                        {categoriasNombres.map(cat => (
                            <button
                                key={cat}
                                onClick={() => setCategoriaActiva(cat)}
                                className={`btn-category ${categoriaActiva === cat ? 'active' : ''}`}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            <div className={`container pt-3 ${esSoloLectura ? 'modo-lectura' : ''}`}>
                {loading ? (
                    <div className="text-center py-5 text-muted">Cargando menú...</div>
                ) : (
                    <CatalogoLista
                        productos={productosFiltrados}
                        carro={carro}
                        onAddItem={handleAdd}
                        onRemoveItem={handleRemove}
                        obtenerUrlImagen={obtenerUrlImagen}
                        esSoloLectura={esSoloLectura}
                        tarjetaRadio={estilosQr.tarjeta_radio}
                        tarjetaSombra={estilosQr.tarjeta_sombra}
                        colorPrimario={headerBg}
                        mostrarPrecios={estilosQr.mostrar_precios !== false}
                    />
                )}
            </div>

            {/* Footer */}
            <footer style={{ backgroundColor: footerBg, color: footerText, padding: '28px 20px 20px', textAlign: 'center' }}>
                {logoFinal && (
                    <img src={logoFinal} alt={configLocal.nombre}
                        style={{ width: '52px', height: '52px', borderRadius: '50%', objectFit: 'cover', marginBottom: '10px', border: `2px solid rgba(255,255,255,0.2)` }} />
                )}
                <div style={{ fontWeight: 700, fontSize: '15px', marginBottom: '4px' }}>{configLocal.nombre}</div>
                {configLocal.direccion && (
                    <div style={{ fontSize: '13px', opacity: 0.7, marginBottom: '4px' }}>📍 {configLocal.direccion}</div>
                )}
                {configLocal.horario && (
                    <div style={{ fontSize: '12px', opacity: 0.6, marginBottom: '14px' }}>🕒 {configLocal.horario}</div>
                )}
                <div style={{ fontSize: '11px', opacity: 0.35 }}>Powered by Komity</div>
            </footer>

            {/* BOTÓN FLOTANTE CARRITO / ENVIAR A COCINA */}
            {carro.length > 0 && !pedidoActivo && !esSoloLectura && !esModoMesa && (
                <div className="fixed-bottom p-3 d-flex justify-content-center" style={{ zIndex: 5000 }}>
                    <button
                        className="btn shadow-lg fw-bold border-0 d-flex justify-content-between align-items-center"
                        style={{
                            backgroundColor: 'var(--pw-btn-primario-bg, #000)',
                            color: 'var(--pw-btn-primario-texto, #fff)',
                            width: '100%',
                            maxWidth: '450px',
                            height: '60px',
                            borderRadius: '18px',
                            padding: '0 20px',
                            boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
                        }}
                        onClick={() => setIsCarritoVisible(true)}>

                        <div className="d-flex align-items-center">
                            <span style={{
                                background: 'rgba(255,255,255,0.2)',
                                padding: '4px 12px',
                                borderRadius: '10px',
                                fontSize: '14px',
                                marginRight: '12px',
                                display: 'inline-block'
                            }}>
                                {carro.reduce((acc, item) => acc + item.cantidad, 0)}
                            </span>
                            <span style={{ letterSpacing: '0.5px', fontSize: '0.95rem' }}>VER CARRITO</span>
                        </div>

                        <span style={{ fontSize: '1.1rem' }}>${subtotal.toLocaleString()}</span>
                    </button>
                </div>
            )}

            {/* 🍽️ BOTÓN FLOTANTE ENVIAR A COCINA (MODO MESA) */}
            {carro.length > 0 && !pedidoActivo && !esSoloLectura && esModoMesa && (
                <div className="fixed-bottom p-3 d-flex justify-content-center" style={{ zIndex: 5000 }}>
                    <button
                        className="btn shadow-lg fw-bold border-0 d-flex justify-content-between align-items-center"
                        style={{
                            backgroundColor: '#28a745',
                            color: '#fff',
                            width: '100%',
                            maxWidth: '450px',
                            height: '60px',
                            borderRadius: '18px',
                            padding: '0 20px',
                            boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
                        }}
                        onClick={() => setIsCarritoVisible(true)}>

                        <div className="d-flex align-items-center">
                            <span style={{
                                background: 'rgba(255,255,255,0.2)',
                                padding: '4px 12px',
                                borderRadius: '10px',
                                fontSize: '14px',
                                marginRight: '12px',
                                display: 'inline-block'
                            }}>
                                {carro.reduce((acc, item) => acc + item.cantidad, 0)}
                            </span>
                            <span style={{ letterSpacing: '0.5px', fontSize: '0.95rem' }}>🍳 ENVIAR A COCINA</span>
                        </div>

                        <span style={{ fontSize: '1.1rem' }}>${subtotal.toLocaleString()}</span>
                    </button>
                </div>
            )}

            {isCarritoVisible && !esModoMesa && (
                <div className="modal-custom">
                    <div className="modal-content-card text-dark shadow-lg">
                        <h5 className="fw-bold mb-4 text-center">Tu Selección</h5>
                        <div className="overflow-auto mb-3 px-1" style={{ maxHeight: '420px' }}>
                            {carro.map((item, index) => (
                                <div key={item.id + "-" + index} className="p-3 mb-3" style={{ border: '1.5px solid #ececec', borderRadius: '16px', backgroundColor: '#ffffff' }}>
                                    <div className="d-flex justify-content-between align-items-start mb-1">
                                        <div className="fw-bold lh-sm text-dark" style={{ fontSize: '1rem', flex: 1 }}>{item.nombre}</div>
                                        <div className="fw-bold text-success ms-2" style={{ fontSize: '1rem' }}>${(Number(item.precio) * item.cantidad).toLocaleString()}</div>
                                    </div>
                                    {(item.variantes_detalles || item.descripcionVariantes) && (
                                        <div className="p-2 mb-2" style={{ backgroundColor: '#f9f9f9', borderRadius: '10px', fontSize: '0.75rem', borderLeft: '4px solid #333' }}>
                                            <div className="text-dark fw-bold mb-1">Personalización:</div>
                                            <div className="text-muted fst-italic">{item.variantes_detalles || item.descripcionVariantes}</div>
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                                        <span className="text-muted small">Cantidad:</span>
                                        <div className="qty-pill">
                                            <button onClick={() => handleRemove(item.id)} className="text-danger">－</button>
                                            <span>{item.cantidad}</span>
                                            <button onClick={() => {
                                                if (item.grupos && item.grupos.length > 0) { setIsCarritoVisible(false); setProductoParaVariantes(item); }
                                                else { handleAdd(item); }
                                            }} className="text-success">＋</button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="p-3 bg-dark text-white rounded-4 mb-3 d-flex justify-content-between align-items-center">
                            <span className="fw-bold">VALOR PRODUCTOS</span>
                            <span className="h4 mb-0 fw-bold">${subtotal.toLocaleString()}</span>
                        </div>
                        <button className="btn btn-success btn-lg w-100 rounded-pill py-3 fw-bold mb-2 shadow" onClick={() => { setIsCarritoVisible(false); setIsFormVisible(true); }}>
                            🚀 CONTINUAR AL PAGO
                        </button>
                        <button className="btn btn-link w-100 text-muted text-decoration-none" onClick={() => setIsCarritoVisible(false)}>
                            <small>Agregar más productos</small>
                        </button>
                    </div>
                </div>
            )}

            {/* 🍽️ MODAL CARRITO MESA - ENVIAR A COCINA */}
            {isCarritoVisible && esModoMesa && (
                <div className="modal-custom">
                    <div className="modal-content-card text-dark shadow-lg">
                        <h5 className="fw-bold mb-4 text-center">🍽️ Tu Pedido en Mesa</h5>
                        <div className="overflow-auto mb-3 px-1" style={{ maxHeight: '420px' }}>
                            {carro.map((item, index) => (
                                <div key={item.id + "-" + index} className="p-3 mb-3" style={{ border: '1.5px solid #ececec', borderRadius: '16px', backgroundColor: '#ffffff' }}>
                                    <div className="d-flex justify-content-between align-items-start mb-1">
                                        <div className="fw-bold lh-sm text-dark" style={{ fontSize: '1rem', flex: 1 }}>{item.nombre}</div>
                                        <div className="fw-bold text-success ms-2" style={{ fontSize: '1rem' }}>${(Number(item.precio) * item.cantidad).toLocaleString()}</div>
                                    </div>
                                    {(item.variantes_detalles || item.descripcionVariantes) && (
                                        <div className="p-2 mb-2" style={{ backgroundColor: '#f9f9f9', borderRadius: '10px', fontSize: '0.75rem', borderLeft: '4px solid #333' }}>
                                            <div className="text-dark fw-bold mb-1">Personalización:</div>
                                            <div className="text-muted fst-italic">{item.variantes_detalles || item.descripcionVariantes}</div>
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                                        <span className="text-muted small">Cantidad:</span>
                                        <div className="qty-pill">
                                            <button onClick={() => handleRemove(item.id)} className="text-danger">－</button>
                                            <span>{item.cantidad}</span>
                                            <button onClick={() => {
                                                if (item.grupos && item.grupos.length > 0) { setIsCarritoVisible(false); setProductoParaVariantes(item); }
                                                else { handleAdd(item); }
                                            }} className="text-success">＋</button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="p-3 bg-dark text-white rounded-4 mb-3 d-flex justify-content-between align-items-center">
                            <span className="fw-bold">VALOR</span>
                            <span className="h4 mb-0 fw-bold">${subtotal.toLocaleString()}</span>
                        </div>
                        <p className="text-center text-muted small mb-3">
                            Al enviar, tu pedido irá directo a cocina 🍳
                        </p>
                        <button
                            className="btn btn-lg w-100 rounded-pill py-3 fw-bold mb-2 shadow border-0"
                            style={{ backgroundColor: '#28a745', color: '#fff' }}
                            onClick={enviarPedidoMesa}
                            disabled={enviandoMesa}
                        >
                            {enviandoMesa ? '⏳ ENVIANDO...' : '🍳 ENVIAR A COCINA'}
                        </button>
                        <button className="btn btn-link w-100 text-muted text-decoration-none" onClick={() => setIsCarritoVisible(false)}>
                            <small>Agregar más productos</small>
                        </button>
                    </div>
                </div>
            )}

            {isFormVisible && !esSoloLectura && (
                <div className="modal-custom">
                    <div className="modal-content-card text-dark">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* Espacio vacío para centrar el título perfectamente */}
                            <div style={{ width: '30px' }}></div>

                            <h5 className="fw-bold m-0 text-center">
                                {esperandoValidacion ? "Validar WhatsApp 📱" : "Datos de tu Pedido 📝"}
                            </h5>

                            <button
                                onClick={() => {
                                    setIsFormVisible(false);
                                    setEsperandoValidacion(false);
                                }}
                                style={{
                                    background: '#eee',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '30px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    color: '#333',
                                    fontSize: '1.2rem',
                                    fontWeight: 'bold',
                                    transition: '0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.background = '#ddd'}
                                onMouseOut={(e) => e.target.style.background = '#eee'}
                            >
                                ×
                            </button>
                        </div>
                        {!esperandoValidacion ? (
                            <>
                                <div className="d-flex mb-4 bg-light rounded-pill p-1 border">
                                    <button type="button" className={`btn w-50 rounded-pill fw-bold ${tipoEntrega === 'delivery' ? 'btn-primary shadow-sm' : 'btn-light text-muted border-0'}`} style={tipoEntrega === 'delivery' ? { backgroundColor: configLocal.colorPrimario, color: '#fff', border: 'none' } : {}} onClick={() => setTipoEntrega('delivery')}>🛵 Delivery</button>
                                    <button type="button" className={`btn w-50 rounded-pill fw-bold ${tipoEntrega === 'retiro' ? 'btn-primary shadow-sm' : 'btn-light text-muted border-0'}`} style={tipoEntrega === 'retiro' ? { backgroundColor: configLocal.colorPrimario, color: '#fff', border: 'none' } : {}} onClick={() => setTipoEntrega('retiro')}>🏪 Retiro Local</button>
                                </div>
                                <input type="text" className="form-control mb-2 p-3 bg-light border-0 rounded-3" placeholder="Nombre completo" value={datosCliente.nombre} onChange={e => setDatosCliente({ ...datosCliente, nombre: e.target.value })} />
                                <input type="tel" className="form-control mb-3 p-3 bg-light border-0 rounded-3" placeholder="Teléfono (Ej: 9 1234 5678)" value={datosCliente.telefono} onChange={e => setDatosCliente({ ...datosCliente, telefono: e.target.value })} />

                                {tipoEntrega === 'delivery' && (
                                    <div className="mb-3 border p-2 rounded-3 bg-light">
                                        <label className="fw-bold text-muted small d-block mb-2"><i className="fas fa-map-marker-alt text-danger mr-1"></i> Escribe tu dirección y selecciónala:</label>

                                        {isLoaded ? (
                                            <>
                                                <Autocomplete onLoad={setAutocompleteInstance} onPlaceChanged={onPlaceChanged} options={{ componentRestrictions: { country: "cl" } }}>
                                                    <input type="text" className="form-control p-3 border-primary mb-2 shadow-sm" style={{ borderRadius: '10px' }} placeholder="Ej: Avenida Providencia 1234" value={datosCliente.direccion} onChange={e => setDatosCliente({ ...datosCliente, direccion: e.target.value })} />
                                                </Autocomplete>

                                                <div className="rounded overflow-hidden shadow-sm" style={{ height: '200px', border: '2px solid #ccc' }}>
                                                    <GoogleMap mapContainerStyle={{ width: '100%', height: '100%' }} center={mapCenter} zoom={marcador ? 16 : 13} onClick={onMapClick} options={{ disableDefaultUI: true, zoomControl: true }}>
                                                        {sectores.map((s, i) => (
                                                            <Polygon key={s.id || i} paths={s.poligono} options={{ fillColor: "#28a745", fillOpacity: 0.3, strokeColor: "#28a745", strokeOpacity: 1, strokeWeight: 2, clickable: false }} />
                                                        ))}
                                                        {marcador && <Marker position={marcador} animation={window.google.maps.Animation.DROP} />}
                                                    </GoogleMap>
                                                </div>

                                                {fueraDeRango && (
                                                    <div className="alert alert-danger mt-2 small fw-bold text-center anim-pulse">
                                                        ❌ Lo sentimos, esta ubicación está fuera de nuestra zona de reparto.
                                                    </div>
                                                )}

                                                {!fueraDeRango && sectorElegido && (
                                                    <div className="alert alert-success mt-2 small fw-bold text-center">
                                                        ✅ Estás en: {sectorElegido.nombre_sector} (+${Number(sectorElegido.valor_entrega).toLocaleString()})
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div className="text-center p-3">Cargando mapa...</div>
                                        )}
                                    </div>
                                )}

                                <textarea className="form-control mb-3 p-3 bg-light border-0 rounded-3" rows="2" placeholder="Alguna nota (Sin cebolla, etc.)" value={datosCliente.observacion} onChange={e => setDatosCliente({ ...datosCliente, observacion: e.target.value })} />

                                {/* 💳 SELECTOR DE MÉTODO DE PAGO */}
                                <div className="mb-3 p-3 bg-white border border-secondary border-opacity-25 rounded-3">
                                    <h6 className="fw-bold mb-2 text-center border-bottom pb-2">💳 Método de Pago</h6>
                                    <div className="d-flex flex-wrap gap-2 justify-content-center">
                                        {(METODOS_PAGO[tipoEntrega] || []).map(mp => (
                                            <button
                                                key={mp.id}
                                                type="button"
                                                onClick={() => setMetodoPago(mp.id)}
                                                style={{
                                                    flex: '1 1 auto',
                                                    minWidth: '100px',
                                                    padding: '10px 14px',
                                                    borderRadius: '12px',
                                                    border: metodoPago === mp.id ? `2px solid ${configLocal.colorPrimario || '#000'}` : '2px solid #e0e0e0',
                                                    background: metodoPago === mp.id ? '#f0fdf4' : '#fff',
                                                    color: metodoPago === mp.id ? '#111' : '#666',
                                                    fontWeight: metodoPago === mp.id ? 800 : 500,
                                                    fontSize: '0.85rem',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                <div>{mp.label}</div>
                                                <div style={{ fontSize: '0.65rem', fontWeight: 400, opacity: 0.7 }}>{mp.desc}</div>
                                            </button>
                                        ))}
                                    </div>
                                    {!metodoPago && (
                                        <div className="text-center text-muted small mt-2">Selecciona cómo deseas pagar</div>
                                    )}

                                    {/* 🏦 DATOS DE TRANSFERENCIA */}
                                    {metodoPago === 'transferencia' && metodosPagoServidor && (
                                        <div className="mt-3 p-3 rounded-3" style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                                            <div className="fw-bold text-success small mb-2">🏦 Datos para Transferencia</div>
                                            <div className="small" style={{ lineHeight: '1.8' }}>
                                                {metodosPagoServidor.banco && <div>🏛 <strong>Banco:</strong> {metodosPagoServidor.banco}</div>}
                                                {metodosPagoServidor.tipo_cuenta && <div>📋 <strong>Tipo:</strong> {metodosPagoServidor.tipo_cuenta}</div>}
                                                {metodosPagoServidor.numero_cuenta && <div>🔢 <strong>N° Cuenta:</strong> {metodosPagoServidor.numero_cuenta}</div>}
                                                {metodosPagoServidor.titular && <div>👤 <strong>Titular:</strong> {metodosPagoServidor.titular}</div>}
                                                {metodosPagoServidor.rut && <div>🆔 <strong>RUT:</strong> {metodosPagoServidor.rut}</div>}
                                                {metodosPagoServidor.email && <div>📧 <strong>Email:</strong> {metodosPagoServidor.email}</div>}
                                            </div>
                                            <div className="mt-2 text-muted small" style={{ fontSize: '0.7rem' }}>
                                                ⚠️ Una vez realizada la transferencia, puedes adjuntar el comprobante abajo.
                                            </div>
                                        </div>
                                    )}

                                    {/* 📎 SUBIR COMPROBANTE (solo si eligió transferencia) */}
                                    {metodoPago === 'transferencia' && (
                                        <div className="mt-3 p-3 rounded-3" style={{ backgroundColor: '#f8f9fa', border: '1px dashed #dee2e6' }}>
                                            <div className="fw-bold small mb-2">📎 Comprobante de Pago (opcional)</div>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                style={{ display: 'none' }}
                                                id="comprobanteInput"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file) {
                                                        setComprobanteFile(file);
                                                        const reader = new FileReader();
                                                        reader.onloadend = () => setComprobantePreview(reader.result);
                                                        reader.readAsDataURL(file);
                                                    }
                                                }}
                                            />
                                            <label htmlFor="comprobanteInput" className="btn btn-outline-secondary btn-sm w-100 fw-bold" style={{ borderRadius: '10px' }}>
                                                {comprobantePreview ? '📷 Cambiar comprobante' : '📷 Subir foto del comprobante'}
                                            </label>
                                            {comprobantePreview && (
                                                <div className="mt-2 text-center">
                                                    <img src={comprobantePreview} alt="Comprobante"
                                                        style={{ maxHeight: '100px', borderRadius: '8px', border: '1px solid #dee2e6' }} />
                                                    <div className="text-success small mt-1">✅ Comprobante seleccionado</div>
                                                </div>
                                            )}
                                            <div className="text-muted mt-1" style={{ fontSize: '0.65rem' }}>
                                                Sube una foto del comprobante para que el local lo tenga como respaldo.
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="mb-3 shadow-sm bg-white border border-secondary border-opacity-25 rounded-3 p-3">
                                    <h6 className="fw-bold mb-3 text-center border-bottom pb-2">Resumen de Cuenta</h6>
                                    <div className="d-flex justify-content-between mb-2 small"><span className="text-muted">Valor Productos:</span><span className="fw-bold">${subtotal.toLocaleString()}</span></div>
                                    <div className="d-flex justify-content-between mb-2 small"><span className="text-muted">Costo Envío:</span><span className={tipoEntrega === 'retiro' ? "fw-bold text-success" : "fw-bold text-danger"}>{tipoEntrega === 'retiro' ? 'Gratis ($0)' : `+$${(sectorElegido ? Number(sectorElegido.valor_entrega) : 0).toLocaleString()}`}</span></div>
                                    <div className="d-flex justify-content-between fw-bold text-success border-top pt-2 mt-2 h5 mb-0"><span>TOTAL A PAGAR:</span><span>${totalFinal.toLocaleString()}</span></div>

                                    {tipoEntrega === 'delivery' && sectorElegido && subtotal < Number(sectorElegido.monto_minimo_pedido || 0) && (
                                        <div className="text-danger small mt-3 text-center fw-bold anim-pulse p-2 bg-danger bg-opacity-10 rounded">❌ Mínimo de compra: ${Number(sectorElegido.monto_minimo_pedido || 0).toLocaleString()}</div>
                                    )}
                                </div>
                                {!captchaOk ? (
                                    <div className="p-3 border rounded-4 bg-light mb-3 text-center border-primary">
                                        <label className="small fw-bold d-block mb-2">
                                            {captchaBloqueado ? (
                                                <span className="text-danger">⏳ Demasiados intentos. Espera 5 segundos...</span>
                                            ) : (
                                                <>Toca el <span className="text-decoration-underline fw-bold">{captchaData.correcto.emoji} {captchaData.correcto.nombre}</span> para verificar</>
                                            )}
                                        </label>
                                        <div className="d-flex justify-content-around">
                                            {captchaData.opciones.map(item => (
                                                <button
                                                    key={item.emoji}
                                                    type="button"
                                                    className={`btn border-0 fs-1 ${captchaBloqueado ? 'disabled' : ''}`}
                                                    disabled={captchaBloqueado}
                                                    onClick={() => handleCaptchaClick(item.emoji)}
                                                    style={{ opacity: captchaBloqueado ? 0.5 : 1, transition: '0.2s' }}
                                                >
                                                    {item.emoji}
                                                </button>
                                            ))}
                                        </div>
                                        {captchaFallos > 0 && !captchaBloqueado && (
                                            <div className="text-danger small mt-2">
                                                ❌ Intento {captchaFallos}/3 fallido. Selecciona el correcto.
                                            </div>
                                        )}
                                    </div>
                                ) : <div className="alert alert-success py-1 text-center fw-bold rounded-pill mb-3 small">✅ Verificado</div>}
                            </>
                        ) : (
                            <div className="text-center py-2">
                                <p className="small text-muted mb-2">📱 Validación por SMS</p>
                                <p className="text-muted" style={{ fontSize: '0.8rem' }}>Te enviaremos un código de 6 dígitos a tu teléfono <b>{datosCliente.telefono}</b></p>
                                
                                {!codigoEnviado ? (
                                    <button
                                        className="btn btn-primary w-100 rounded-pill py-3 fw-bold mb-3 shadow-sm"
                                        style={{ backgroundColor: configLocal.colorPrimario, border: 'none' }}
                                        onClick={async () => {
                                            setEnviandoCodigo(true);
                                            const tel = prepararTelefonoChile(datosCliente.telefono);
                                            const res = await enviarCodigoValidacion(tel);
                                            setEnviandoCodigo(false);
                                            if (res.status === 'sent') {
                                                setCodigoEnviado(true);
                                                setMensajeValidacion({ tipo: 'success', texto: 'Código enviado. Revisa tu teléfono.' });
                                            } else {
                                                setMensajeValidacion({ tipo: 'danger', texto: res.message || 'Error al enviar código.' });
                                            }
                                        }}
                                        disabled={enviandoCodigo}
                                    >
                                        {enviandoCodigo ? (
                                            <><span className="spinner-border spinner-border-sm me-2" role="status"></span>ENVIANDO...</>
                                        ) : '📨 ENVIAR CÓDIGO SMS'}
                                    </button>
                                ) : (
                                    <>
                                        <input
                                            type="text"
                                            className="form-control form-control-lg text-center fw-bold mb-3"
                                            placeholder="000000"
                                            maxLength={6}
                                            style={{ fontSize: '2.5rem', letterSpacing: '12px', border: '3px solid ' + configLocal.colorPrimario, color: configLocal.colorPrimario }}
                                            value={codigoValidacion}
                                            onChange={e => setCodigoValidacion(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                        />
                                        <p className="text-muted" style={{ fontSize: '0.75rem' }}>Código válido por 5 minutos</p>
                                    </>
                                )}
                                
                                {mensajeValidacion && (
                                    <div className={`alert alert-${mensajeValidacion.tipo} py-2 small text-center rounded-pill mb-3`}>
                                        {mensajeValidacion.texto}
                                    </div>
                                )}
                            </div>
                        )}
                        <button
                            className="btn btn-success w-100 rounded-pill py-3 fw-bold shadow-lg border-0"
                            style={{ backgroundColor: configLocal.colorPrimario }}
                            onClick={finalizarPedido}
                            disabled={loading || (!captchaOk && !esperandoValidacion) || (tipoEntrega === 'delivery' && (fueraDeRango || !sectorElegido || subtotal < Number(sectorElegido.monto_minimo_pedido || 0)))}
                        >
                            {loading ? "PROCESANDO..." : (esperandoValidacion ? "VALIDAR CÓDIGO" : `🚀 ENVIAR PEDIDO POR $${totalFinal.toLocaleString()}`)}
                        </button>
                        <button className="btn btn-link w-100 text-muted mt-2" onClick={() => { setIsFormVisible(false); setEsperandoValidacion(false); }}>Cerrar</button>
                    </div>
                </div>
            )}

            {pedidoActivo && estadoActual !== -1 && (
                <>
                    {datosCliente.verSeguimiento && (
                        <div style={{ position: 'fixed', inset: 0, backgroundColor: '#fff', zIndex: 99999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                        <div className={`display-1 mb-4 anim-${estadosConfig[estadoActual].anim}`}>{estadosConfig[estadoActual].icono}</div>
                            <h2 className="fw-bold text-center px-4 text-dark">{estadosConfig[estadoActual].texto}</h2>
                            <p className="text-muted">Orden #{pedidoActivo.display_id}</p>
                            <div className="w-75 bg-light rounded-pill mt-4 shadow-sm" style={{ height: '12px' }}>
                                <div style={{ width: `${((estadoActual + 1) / estadosConfig.length) * 100}%`, height: '100%', backgroundColor: configLocal.colorPrimario, transition: '1s', borderRadius: '10px' }}></div>
                            </div>

                            {/* 🛒 BOTÓN PARA VER DETALLE */}
                            {pedidoActivo.items && pedidoActivo.items.length > 0 && (
                                <>
                                    <button 
                                        className="btn btn-outline-secondary mt-4 rounded-pill px-4 py-2 fw-bold"
                                        onClick={() => setDatosCliente(prev => ({ ...prev, verDetalle: !prev.verDetalle }))}
                                    >
                                        {datosCliente.verDetalle ? '🛒 OCULTAR DETALLE' : '🛒 VER DETALLE DEL PEDIDO'}
                                    </button>
                                    {datosCliente.verDetalle && (
                                        <div className="w-75 mt-3 p-3 bg-white rounded-4 shadow-sm border" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                            <h6 className="fw-bold text-muted mb-2 text-center border-bottom pb-2">TU PEDIDO</h6>
                                            {pedidoActivo.items.map((item, idx) => (
                                                <div key={idx} className="d-flex justify-content-between align-items-center py-1 border-bottom border-light">
                                                    <div className="text-start" style={{ flex: 1 }}>
                                                        <span className="fw-bold small">{item.cantidad}x {item.nombre}</span>
                                                        {item.variantes_detalles && (
                                                            <div className="text-muted" style={{ fontSize: '0.65rem' }}>{item.variantes_detalles}</div>
                                                        )}
                                                    </div>
                                                    <span className="fw-bold small ms-2">${Number(item.precio * item.cantidad).toLocaleString('es-CL')}</span>
                                                </div>
                                            ))}
                                            <div className="d-flex justify-content-between fw-bold mt-2 pt-2 border-top">
                                                <span>TOTAL</span>
                                                <span style={{ color: configLocal.colorPrimario }}>${Number(pedidoActivo.total).toLocaleString('es-CL')}</span>
                                            </div>
                                            {pedidoActivo.tipo_entrega_id && (
                                                <div className="text-center small text-muted mt-1">
                                                    {pedidoActivo.tipo_entrega_id === 2 ? '🛵 Delivery' : '🏪 Retiro en Local'}
                                                    {pedidoActivo.tipo_entrega_id === 2 && pedidoActivo.direccion && ` - ${pedidoActivo.direccion}`}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                            <button className="btn btn-dark mt-4 rounded-pill px-5" onClick={() => setDatosCliente({ ...datosCliente, verSeguimiento: false, verDetalle: false })}>CERRAR Y VER MENÚ</button>
                            {estadoActual === 3 && <button className="btn btn-success mt-3 rounded-pill px-5 py-3 fw-bold shadow anim-pulse border-0" onClick={resetearParaNuevoPedido}>✨ HACER NUEVO PEDIDO</button>}
                        </div>
                    )}
                    {!datosCliente.verSeguimiento && (
                        <div className="fixed-bottom p-3 d-flex justify-content-end" style={{ zIndex: 10000 }}>
                            <button className="btn shadow-lg rounded-circle d-flex align-items-center justify-content-center border-0"
                                style={{ backgroundColor: configLocal.colorPrimario, width: '75px', height: '75px', color: 'white', border: '3px solid white' }}
                                onClick={() => setDatosCliente({ ...datosCliente, verSeguimiento: true })}>
                                <div className="text-center"><div className="fs-2 mb-0 anim-pulse">{estadosConfig[estadoActual].icono}</div><div style={{ fontSize: '10px', fontWeight: '900' }}>PEDIDO</div></div>
                            </button>
                        </div>
                    )}
                </>
            )}

            {estadoActual === -1 && (
                <div className="modal-custom" style={{ zIndex: 100000, background: 'rgba(0,0,0,0.92)' }}>
                    <div className="modal-content-card text-center border-0" style={{ borderTop: '10px solid #dc3545' }}>
                        <div className="display-1 mb-4">🚫</div>
                        <h2 className="fw-bold text-danger mb-3">PEDIDO CANCELADO</h2>
                        <p className="text-muted mb-4">Lo sentimos, el local ha cancelado tu pedido <b>#{pedidoActivo ? pedidoActivo.display_id : ''}</b>.<br /><small>Puede ser por falta de stock o fuera de rango.</small></p>
                        <button className="btn btn-dark w-100 rounded-pill py-3 fw-bold shadow" onClick={resetearParaNuevoPedido}>ENTENDIDO, VOLVER AL MENÚ</button>
                    </div>
                </div>
            )}

            {pedidoActivo && estadoActual === -1 && !datosCliente.verSeguimiento && (
                <div className="fixed-bottom p-3 d-flex justify-content-end" style={{ zIndex: 10000 }}>
                    <button className="btn shadow-lg rounded-circle d-flex align-items-center justify-content-center border-0"
                        style={{ backgroundColor: '#dc3545', width: '75px', height: '75px', color: 'white', border: '3px solid white' }}
                        onClick={() => setEstadoActual(-1)}>
                        <div className="text-center"><div className="fs-2 mb-0 anim-pulse">❗</div><div style={{ fontSize: '10px', fontWeight: '900' }}>AVISO</div></div>
                    </button>
                </div>
            )}

            {productoParaVariantes && (
                <SelectorVariantesModal item={productoParaVariantes} onClose={() => setProductoParaVariantes(null)} onConfirm={(itemFinal) => { handleAdd(itemFinal); setProductoParaVariantes(null); setIsCarritoVisible(true); }} />
            )}
        </div>
    );
};

export default Pedidos;